"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ommitImgProps = exports.ommitImgWraperProps = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _theme = require("../theme");

var _ommitProps = require("../../utils/ommit-props");

var _styles = _interopRequireWildcard(require("./styles"));

var _Img = _interopRequireDefault(require("./components/Img"));

var _core = require("@emotion/core");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  position: absolute;\n  border-radius: inherit;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var ommitImgWraperProps = (0, _ommitProps.ommitProps)(['width', 'height', 'imageFit', 'fitContainer', 'innerRef', 'shape']);
exports.ommitImgWraperProps = ommitImgWraperProps;
var ommitImgProps = (0, _ommitProps.ommitProps)(['shape', 'imageFit', 'fitContainer', 'innerRef', 'isImageLoaded']);
exports.ommitImgProps = ommitImgProps;
var ImageWrapper = (0, _theme.styled)('div', {
  shouldForwardProp: ommitImgWraperProps
})(_styles.default.getShapeStyle, _styles.default.getFillStyle);
var OverlayWrapper = (0, _theme.styled)('div')(_templateObject());

var Image =
/*#__PURE__*/
function (_React$PureComponent) {
  (0, _inherits2.default)(Image, _React$PureComponent);
  (0, _createClass2.default)(Image, null, [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, prevState) {
      if (props.src !== prevState.src) {
        return {
          src: props.src,
          isImageLoaded: false
        };
      }

      return null;
    }
  }]);

  function Image(props) {
    var _this;

    (0, _classCallCheck2.default)(this, Image);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Image).call(this, props));

    _this.setImageSizes = function () {
      var _this$props = _this.props,
          width = _this$props.width,
          height = _this$props.height;

      if (_this.props.imageFit) {
        _this.wrapperOptions = _this.buildStyle(width, height);
      } else {
        _this.imageOptions = {
          width: width,
          height: height
        };
      }
    };

    _this.computeCoverContainStyle = function () {
      var _this$props2 = _this.props,
          width = _this$props2.width,
          height = _this$props2.height,
          imageFit = _this$props2.imageFit;

      if ((imageFit === 'cover' || imageFit === 'contain') && _this.imageElement && _this.wrapperElement) {
        var targetRatio = null;

        if (!!width && !!height) {
          // if width/height are provided will just use those, otherwise find it
          targetRatio = width / height;

          if (isNaN(targetRatio)) {
            targetRatio = _this.wrapperElement.current.clientWidth / _this.wrapperElement.current.clientHeight;
          }
        } else {
          targetRatio = _this.wrapperElement.current.clientWidth / _this.wrapperElement.current.clientHeight;
        }

        var imageNaturalRatio = _this.imageElement.current.naturalWidth / _this.imageElement.current.naturalHeight;

        if (imageNaturalRatio > targetRatio) {
          // decide if we want to crop horizontally or vertically
          _this.imageClassName = imageFit === 'cover' ? _styles.landscapeStyle : _styles.portraitStyle;
        } else {
          _this.imageClassName = imageFit === 'cover' ? _styles.portraitStyle : _styles.landscapeStyle;
        }
      }
    };

    _this.handleImageLoad = function (e) {
      if (_this.props.imageFit === 'cover' || _this.props.imageFit === 'contain') {
        _this.computeCoverContainStyle();
      }

      if (typeof _this.props.onLoad === 'function') {
        _this.props.onLoad(e);
      }

      _this.setState({
        isImageLoaded: true
      });
    };

    _this.buildStyle = function (width, height) {
      var style = {};

      if (width) {
        style.width = "".concat(width, "px");
      }

      if (height) {
        style.height = "".concat(height, "px");
      }

      return style;
    };

    _this.wrapperOptions = {};
    _this.imageOptions = {};
    _this.imageClassName = {};
    _this.imageElement = _react.default.createRef();
    _this.wrapperElement = _react.default.createRef();

    _this.setImageSizes();

    _this.state = {
      isImageLoaded: false,
      src: props.src
    };
    return _this;
  }

  (0, _createClass2.default)(Image, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var image = this.imageElement.current;

      if (!image || !this.state.src || this.state.isImageLoaded) {
        return;
      } // Rehydrate after server side render
      // Without this the onLoad handler never fires on the client


      image.src = this.state.src;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          children = _this$props3.children,
          className = _this$props3.className,
          fitContainer = _this$props3.fitContainer,
          height = _this$props3.height,
          imageFit = _this$props3.imageFit,
          placeholder = _this$props3.placeholder,
          shape = _this$props3.shape,
          theme = _this$props3.theme,
          width = _this$props3.width,
          wrapperClassName = _this$props3.wrapperClassName,
          wrapperStyle = _this$props3.wrapperStyle,
          restProps = (0, _objectWithoutProperties2.default)(_this$props3, ["children", "className", "fitContainer", "height", "imageFit", "placeholder", "shape", "theme", "width", "wrapperClassName", "wrapperStyle"]);
      var src = this.state.src;
      var defaultPlaceholder = // eslint-disable-next-line react/prop-types
      typeof theme.components.image.defaultImage === 'function' ? // eslint-disable-next-line react/prop-types
      theme.components.image.defaultImage() : // eslint-disable-next-line react/prop-types
      theme.components.image.defaultImage;
      return (0, _core.jsx)(ImageWrapper, {
        shape: shape,
        className: wrapperClassName,
        imageFit: imageFit,
        width: width,
        height: height,
        fitContainer: fitContainer,
        ref: this.wrapperElement,
        style: _objectSpread({}, this.wrapperOptions, {}, wrapperStyle)
      }, (0, _core.jsx)("div", {
        css: _styles.respectOverflow
      }, (0, _core.jsx)(_Img.default, (0, _extends2.default)({
        isImageLoaded: this.state.isImageLoaded,
        className: className,
        css: this.imageClassName,
        imageFit: imageFit,
        shape: shape
      }, this.imageOptions, restProps, {
        src: src || placeholder || defaultPlaceholder,
        ref: this.imageElement,
        onLoad: this.handleImageLoad
      }))), children && (0, _core.jsx)(OverlayWrapper, null, children));
    }
  }]);
  return Image;
}(_react.default.PureComponent);

Image.defaultProps = {
  shape: 'square'
};

var _default = (0, _theme.withTheme)(Image);

exports.default = _default;